import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const CAPABILITIES_PATH = "/capabilities";
export const CAPABILITIES_RETURN_STATE = { from: "capabilities" };

const FLAG_KEY = "dsite:from-capabilities";
const DEST_KEY = "dsite:from-capabilities-dest";

function pathOnly(href) {
  if (!href || typeof href !== "string") return "";
  return href.split("?")[0].split("#")[0];
}

export function isCapabilitiesOutbound(href) {
  const path = pathOnly(href);
  if (!path.startsWith("/")) return false;
  if (path === "/" || path === CAPABILITIES_PATH) return false;
  return true;
}

export function markFromCapabilities(href) {
  const path = pathOnly(href);
  if (!isCapabilitiesOutbound(path)) return;
  try {
    sessionStorage.setItem(FLAG_KEY, "1");
    sessionStorage.setItem(DEST_KEY, path);
  } catch {
    /* ignore private-mode quota */
  }
}

export function clearFromCapabilities() {
  try {
    sessionStorage.removeItem(FLAG_KEY);
    sessionStorage.removeItem(DEST_KEY);
  } catch {
    /* ignore */
  }
}

function storedDest() {
  try {
    if (sessionStorage.getItem(FLAG_KEY) !== "1") return "";
    return sessionStorage.getItem(DEST_KEY) || "";
  } catch {
    return "";
  }
}

export function shouldShowCapabilitiesReturn(location) {
  if (location?.state?.from === "capabilities") return true;
  const dest = storedDest();
  return Boolean(dest && dest === location?.pathname);
}

export function useCapabilitiesReturn() {
  const location = useLocation();
  return shouldShowCapabilitiesReturn(location);
}

/** Keeps same-tab reload working and clears context on independent entry. */
export function CapabilitiesReturnTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path === CAPABILITIES_PATH) return;
    if (location.state?.from === "capabilities") {
      markFromCapabilities(path);
      return;
    }
    const dest = storedDest();
    if (dest && dest !== path) {
      clearFromCapabilities();
    }
  }, [location.pathname, location.state, location.key]);

  return null;
}
